import React from 'react';
import './EmptyState.css';

const EmptyState = ({ icon, title, description, action }) => {
  const renderIcon = () => {
    switch (icon) {
      case 'draft':
        return (
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <rect x="12" y="8" width="40" height="48" rx="4" stroke="currentColor" strokeWidth="2"/>
            <path d="M20 20H44" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M20 28H44" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M20 36H36" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M20 44H32" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
      case 'published':
        return (
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="24" stroke="currentColor" strokeWidth="2"/>
            <path d="M22 32L29 39L42 26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        );
      case 'search':
        return (
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="28" cy="28" r="16" stroke="currentColor" strokeWidth="2"/>
            <path d="M40 40L52 52" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
      default:
        return (
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <rect x="8" y="8" width="48" height="48" rx="8" stroke="currentColor" strokeWidth="2"/>
            <path d="M32 20V44M20 32H44" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        );
    }
  };

  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        {renderIcon()}
      </div>
      <h3 className="empty-state-title">{title}</h3>
      {description && (
        <p className="empty-state-description">{description}</p>
      )}
      {action && (
        <div className="empty-state-action">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
